import * as React from "react";
import * as moment from "moment";
import {
    D_MMM_YYYY_DATE_FORMAT,
    Instalment,
    INSTALMENT_STATUS_PENDING_PAYMENT,
    InstalmentsInfo
} from "@ferry/journey-services";
import {InfoModal} from "../modals/InfoModal";
import {PricingExplainedInfo} from "../PricingExplainedInfo";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";

interface IProps {
    showInfoModal: boolean,
    smallScreenMarginRequired?: boolean,
    instalmentsInfo: InstalmentsInfo
}

export class NextPaymentBanner extends React.Component<IProps> {

    private static renderInfoModal() {
        return (
            <InfoModal title="Pricing explained">
                <PricingExplainedInfo/>
            </InfoModal>
        );
    }

    public render(): React.ReactNode {
        const instalmentsInfo: InstalmentsInfo = this.props.instalmentsInfo;
        const additionalWording: string = this.getChangePaymentDayWording(this.props.instalmentsInfo);

        if (instalmentsInfo?.nextInstalmentDate && instalmentsInfo?.nextInstalmentAmount) {
            const paymentDate = moment(instalmentsInfo.nextInstalmentDate);

            return (
                <div className={`banner info-banner ${this.props.smallScreenMarginRequired ? "small-screen-margin" : ""}`}>
                    {this.props.showInfoModal && NextPaymentBanner.renderInfoModal()}
                    {!this.props.showInfoModal && <div className="banner-icon"></div>}
                    <div className="banner-text">
                        Your next instalment of{' '}
                        <span className="font-weight-bold"
                              id="next-payment-amount">{getAmountWithDecimalDigits(instalmentsInfo.nextInstalmentAmount)} </span>
                        is due on {paymentDate.format(D_MMM_YYYY_DATE_FORMAT)}.
                        {additionalWording}
                    </div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }

    private getChangePaymentDayWording(instalmentsInfo: InstalmentsInfo): string {
        let additionalWording: string = "";

        const pendingPaymentInstalments: Instalment[] = instalmentsInfo.instalments.filter(
            (instalment: Instalment) => instalment.status === INSTALMENT_STATUS_PENDING_PAYMENT && !instalment.description.includes("Deposit"));
        const dueDates: Date[] = pendingPaymentInstalments.map((instalment: Instalment) => new Date(instalment.dueDate));

        if (dueDates.length >= 1) {
            const nextDueDate: Date = dueDates[0];
            const afterNextDueDate: Date = dueDates[1];

            if (nextDueDate && afterNextDueDate && moment(nextDueDate).month() === moment().month() && moment(nextDueDate).date() > moment().date()
                && moment(nextDueDate).date() !== moment(afterNextDueDate).date()) {

                additionalWording = " Future payments will be collected on your new chosen date.";
            }
        }

        return additionalWording;
    }
}
